export default {
  dados:{}
};
